exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.q-table tbody td.expantedRow {\n  border-top: 1px double;\n\n  font-weight: bold;\n}\n.q-table tbody td.expantedRow.controlCell {\n  border-left: 1px double;\n}\n.el-autocomplete-suggestion li {\n  padding: 2px !important;\n}\n.printingSheme {\n  background: white;\n  color: black;\n}\n", ""]);

// exports
